import FeatureGates from '@atlaskit/feature-gate-js-client';

import { addFeatureFlagExposureToSentry } from './add-feature-flag-exposure-to-sentry';

export type FeatureFlagManifest = {
	[k: string]: FeatureFlag;
};

export type FeatureFlagMetadata = {
	/**
	 * The description of the feature flag.
	 */
	description: string;

	/**
	 * The expected release date
	 */
	expectedReleaseDate: string;

	/**
	 * The expected runtime
	 */
	expectedRuntime: string;

	/**
	 *  Additional context
	 */
	context: FeatureFlagContext;
};

export type FeatureFlag = {
	/**
	 * The name of the feature flag.
	 */
	featureFlagName: string;

	/**
	 * The metadata
	 */
	metadata: FeatureFlagMetadata;
};

export type FeatureFlagContext = {
	/**
	 * Urls that experiment will run on
	 * Accepts singular urls such as "/software/jira", "/software/jira/pricing"
	 * or wildcard "*" indicating experiment is global
	 * or combination of both such as "/agile/*"
	 */
	urls: string[];
};

/**
 * Function that checks the gate for particular feature flag
 * @param featureFlag Takes in a feature flag from the feature flag manifest
 */
export function checkFeatureFlagGate(featureFlag: FeatureFlag): boolean {
	const { featureFlagName } = featureFlag;
	const value = FeatureGates.checkGate(featureFlagName);
	addFeatureFlagExposureToSentry(featureFlagName, value);
	return value;
}
